'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTimeFormatter = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _DateTimeFormats = require('./DateTimeFormats');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function momentFormatting(dateTime, format) {
  return dateTime ? (0, _moment2['default'])(dateTime).format(format) : null;
}

function momentUtcFormatting(dateTime, format) {
  return dateTime ? _moment2['default'].utc(dateTime).format(format) : null;
}

function convertToTime(dateTime) {
  return momentFormatting(dateTime, _DateTimeFormats.DateTimeFormats.TIME);
}

function convertToUtc(dateTime, utcOffset) {
  return _moment2['default'].utc(dateTime).utcOffset(utcOffset);
}

var DateTimeFormatter = exports.DateTimeFormatter = {
  convertStringToMoment: function convertStringToMoment(dateTimeString, format) {
    var dateFormat = format || _DateTimeFormats.DateTimeFormats.DATETIME;
    return (0, _moment2['default'])(dateTimeString, dateFormat);
  },
  withFormatString: function withFormatString(dateTime, formatString) {
    return momentFormatting(dateTime, formatString);
  },
  dateTime: function dateTime(_dateTime) {
    return momentFormatting(_dateTime, _DateTimeFormats.DateTimeFormats.DATETIME);
  },
  date: function date(dateTime) {
    return momentFormatting(dateTime, _DateTimeFormats.DateTimeFormats.DATE);
  },
  time: function time(dateTime) {
    return convertToTime(dateTime);
  },
  timeSec: function timeSec(dateTime) {
    return momentFormatting(dateTime, _DateTimeFormats.DateTimeFormats.TIME_WITH_SECONDS);
  },
  timePrecise: function timePrecise(dateTime) {
    return momentFormatting(dateTime, _DateTimeFormats.DateTimeFormats.TIME_PRECISE);
  },
  // eslint-disable-next-line complexity
  timeDaysDifference: function timeDaysDifference(dateTime, endDate) {
    function formatShortTime(daysDiff) {
      return daysDiff > 0 ? convertToTime(endDate) + ' (+' + daysDiff + ')' : convertToTime(endDate) + ' (' + daysDiff + ')';
    }

    if (!dateTime || !endDate) {
      return null;
    }

    var start = (0, _moment2['default'])(dateTime).startOf('day');
    var end = (0, _moment2['default'])(endDate).startOf('day');
    var daysDiff = end.diff(start, 'days'); // if there is a difference in days then we need to format the display differently

    return daysDiff !== 0 ? formatShortTime(daysDiff) : convertToTime(endDate);
  },
  // eslint-disable-next-line complexity
  timeDaysDifferenceLocal: function timeDaysDifferenceLocal(dateTime, endDate) {
    function formatShortTimeLocal(daysDiff) {
      return daysDiff > 0 ? convertToTime(endDate) + 'L (+' + daysDiff + ')' : convertToTime(endDate) + 'L (' + daysDiff + ')';
    }

    if (!dateTime || !endDate) {
      return null;
    }

    var start = (0, _moment2['default'])(dateTime).startOf('day');
    var end = (0, _moment2['default'])(endDate).startOf('day');
    var daysDiff = end.diff(start, 'days'); // if there is a difference in days then we need to format the display differently

    return daysDiff !== 0 ? formatShortTimeLocal(daysDiff) : convertToTime(endDate) + 'L';
  },
  dateTimeLocal: function dateTimeLocal(dateTime, utcOffset) {
    if (!dateTime || !utcOffset) {
      return null;
    }

    var dateTimeLocal = _moment2['default'].utc(dateTime).utcOffset(utcOffset * 60).format(_DateTimeFormats.DateTimeFormats.DATETIME);

    return dateTimeLocal + 'L';
  },
  dateTimeSec: function dateTimeSec(dateTime) {
    return momentFormatting(dateTime, _DateTimeFormats.DateTimeFormats.DATETIME_SECONDS);
  },
  timestamp: function timestamp(dateTime) {
    return momentFormatting(dateTime, _DateTimeFormats.DateTimeFormats.TIME_STAMP);
  },
  dateTimeZulu: function dateTimeZulu(dateTime) {
    return momentFormatting(dateTime, _DateTimeFormats.DateTimeFormats.DATETIME_ZULU);
  },
  dateTimeSecZulu: function dateTimeSecZulu(dateTime) {
    return momentFormatting(dateTime, _DateTimeFormats.DateTimeFormats.DATETIME_ZULU_WITH_SECONDS);
  },
  timestampZulu: function timestampZulu(dateTime) {
    return momentFormatting(dateTime, _DateTimeFormats.DateTimeFormats.TIME_STAMP_ZULU);
  },
  dateIata: function dateIata(dateTime) {
    return momentFormatting(dateTime, _DateTimeFormats.DateTimeFormats.DATE_IATA);
  },
  timeIata: function timeIata(dateTime) {
    return momentFormatting(dateTime, _DateTimeFormats.DateTimeFormats.TIME_IATA);
  },
  timeSecIata: function timeSecIata(dateTime) {
    return momentFormatting(dateTime, _DateTimeFormats.DateTimeFormats.TIME_IATA_WITH_SECONDS);
  },
  dateTimeUtc: function dateTimeUtc(dateTime) {
    return momentUtcFormatting(dateTime, _DateTimeFormats.DateTimeFormats.DATETIME);
  },
  dateTimeNoConversion: function dateTimeNoConversion(dateTime) {
    if (!dateTime) {
      return null;
    }

    return _moment2['default'].utc(dateTime).format(_DateTimeFormats.DateTimeFormats.DATETIME);
  },
  dateUtcToLocal: function dateUtcToLocal(dateTime, utcOffset) {
    return '' + convertToUtc(dateTime, utcOffset).format(_DateTimeFormats.DateTimeFormats.DATE);
  },
  timeUtcToLocal: function timeUtcToLocal(dateTime, utcOffset) {
    return convertToUtc(dateTime, utcOffset).format(_DateTimeFormats.DateTimeFormats.TIME) + 'L';
  },
  timeLocal: function timeLocal(dateTime) {
    return convertToTime(dateTime) + 'L';
  }
};